module.exports = __webpack_public_path__ + "static/power1-2-c34ddf8e435645b18cb2196c119ee8a4.png";